import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
    faInstagram,
    faLinkedinIn,
    faWhatsapp
} from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Footer.css';

const Footer = () => {

    return (
        <section className='row footer'>

            <Row className="col-md-11 mx-auto">

                <Col md={6} lg={4} className="fAboutUs">

                    <h5>NextGen Nexus</h5>

                    <span className="animate-border"></span>

                    <p className="aboutUsDes">
                        NextGen Nexus provides modern websites,
                        CRM systems, business automation tools,
                        and custom software solutions for startups,
                        businesses, and enterprises worldwide.
                    </p>

                    <ul className="socialIcons">

                        <li>
                            <a
                                href="https://wa.me/919024711288"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <FontAwesomeIcon icon={faWhatsapp} />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.instagram.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.linkedin.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                        </li>

                    </ul>

                </Col>

                <Col md={6} lg={4}>
                    <h5>Services</h5>

                    <span className="animate-border"></span>

                    <ul className="footerList">
                        <li>Custom CRM Development</li>
                        <li>Website Development</li>
                        <li>Business Automation</li>
                        <li>Software Solutions</li>
                        <li>Dashboard Systems</li>
                    </ul>
                </Col>

                <Col md={6} lg={4}>
                    <h5>Contact Info</h5>

                    <span className="animate-border"></span>

                    <ul className="footerList">
                        <li>Jaipur, Rajasthan, India</li>
                        <li>+91 9521900506</li>
                        <li>info@nextgennexus.in</li>
                        <li>Worldwide Services Available</li>
                    </ul>
                </Col>

            </Row>

            <p className="copyRight">
                Copyright © 2026
                <span className="fHighlight"> NextGenNexus</span>.
                All rights reserved.
            </p>

        </section>
    );
};

export default Footer;